
  // Get the current date
const bundle_currentDate = new Date();

// Months array
const bundle_months = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

// Get the month and date
const bundle_month = bundle_months[bundle_currentDate.getMonth()];
const bundle_date = bundle_currentDate.getDate();

// Function to get the ordinal suffix for the date
function bundle_getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
}

// Append the formatted date to the span tag
document.getElementById("bundle_datePlaceholder").innerText = `${bundle_month} ${bundle_date}${bundle_getOrdinalSuffix(bundle_date)}`;


